import type { Transfer } from '@/types/payout';
import { PayoutTransferStatus } from '@fluenceur/types';

/**
 * The reason the API writes on the transfers of a payout it closed because the
 * brand never paid for it. Mirrors the backend's closure constant: the shared
 * types do not carry it yet.
 */
export const CLOSED_UNPAID_PAYOUT_TRANSFER_REASON = 'batch_closed_unfunded';

/**
 * A closed payout keeps its transfers, marked failed, so the record of what it
 * would have sent survives. None of them was ever attempted: nothing was paid,
 * so nothing could fail. They read as "not sent", never as a payment failure.
 */
export const isTransferNeverSent = (
  transfer: Pick<Transfer, 'status' | 'failureReason'>
): boolean =>
  transfer.status === PayoutTransferStatus.FAILED &&
  transfer.failureReason === CLOSED_UNPAID_PAYOUT_TRANSFER_REASON;

/** The one state a transfer's own status cannot express. */
export const TRANSFER_NOT_SENT = 'not_sent';

export type TransferDisplayStatus = PayoutTransferStatus | typeof TRANSFER_NOT_SENT;

/** What the drawer shows for a transfer: badge and hint both read this, never the raw status. */
export const resolveTransferDisplayStatus = (
  transfer: Pick<Transfer, 'status' | 'failureReason'>
): TransferDisplayStatus => (isTransferNeverSent(transfer) ? TRANSFER_NOT_SENT : transfer.status);
